// extracted by mini-css-extract-plugin
module.exports = {"lastActivity":"lastActivity__xfIGC"};